import { render, staticRenderFns } from "./EntityHandlerSidebar.vue?vue&type=template&id=398998d9&"
import script from "./EntityHandlerSidebar.vue?vue&type=script&lang=js&"
export * from "./EntityHandlerSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports